// P2.2 service-area source of truth. `parent` marks districts; `area` = core | extended.
// Erftstadt has no own marker: its districts (Liblar, Gymnich, Lechenich, Friesheim) carry it.
export const BASE = "Euskirchen";

export const LOCATIONS = [
  { name: "Euskirchen", lat: 50.6613, lng: 6.7873, area: "core" },
  { name: "Bonn", lat: 50.7374, lng: 7.0982, area: "core" },
  { name: "Köln", lat: 50.9375, lng: 6.9603, area: "core" },
  { name: "Brühl", lat: 50.829, lng: 6.9045, area: "core" },
  { name: "Wesseling", lat: 50.827, lng: 6.975, area: "core" },
  { name: "Hürth", lat: 50.8771, lng: 6.8761, area: "core" },
  { name: "Frechen", lat: 50.9119, lng: 6.81, area: "core" },
  { name: "Kerpen", lat: 50.8697, lng: 6.6961, area: "core" },
  { name: "Türnich", parent: "Kerpen", lat: 50.8602, lng: 6.7547, area: "core" },
  { name: "Liblar", parent: "Erftstadt", lat: 50.8147, lng: 6.8133, area: "core" },
  { name: "Gymnich", parent: "Erftstadt", lat: 50.8336, lng: 6.7522, area: "core" },
  { name: "Lechenich", parent: "Erftstadt", lat: 50.7797, lng: 6.77, area: "core" },
  { name: "Friesheim", parent: "Erftstadt", lat: 50.7778, lng: 6.7194, area: "core" },
  { name: "Weilerswist", lat: 50.7519, lng: 6.8467, area: "core" },
  { name: "Swisttal", lat: 50.7333, lng: 6.9333, area: "core" },
  { name: "Bornheim", lat: 50.759, lng: 7.005, area: "core" },
  { name: "Troisdorf", lat: 50.8161, lng: 7.1556, area: "core" },
  { name: "Rheinbach", lat: 50.6256, lng: 6.949, area: "core" },
  { name: "Meckenheim", lat: 50.6236, lng: 7.0286, area: "core" },
  { name: "Zülpich", lat: 50.6919, lng: 6.6522, area: "core" },
  { name: "Vettweiß", lat: 50.7378, lng: 6.598, area: "core" },
  { name: "Nörvenich", lat: 50.8086, lng: 6.6386, area: "core" },
  { name: "Mechernich", lat: 50.595, lng: 6.65, area: "core" },
  { name: "Bad Münstereifel", lat: 50.5536, lng: 6.7631, area: "core" },
  { name: "Kall", lat: 50.542, lng: 6.556, area: "extended" },
  { name: "Nettersheim", lat: 50.4925, lng: 6.6294, area: "extended" },
  { name: "Schleiden", lat: 50.53, lng: 6.475, area: "extended" },
  { name: "Bochum", lat: 51.4818, lng: 7.2162, area: "extended" },
  { name: "Witten", lat: 51.4436, lng: 7.3528, area: "extended" },
  { name: "Herne", lat: 51.5369, lng: 7.2009, area: "extended" },
  { name: "Hattingen", lat: 51.399, lng: 7.1859, area: "extended" },
  { name: "Düren", lat: 50.8044, lng: 6.482, area: "core" },
  { name: "Kreuzau", lat: 50.747, lng: 6.489, area: "core" },
  { name: "Merzenich", lat: 50.827, lng: 6.528, area: "core" },
  { name: "Niederzier", lat: 50.879, lng: 6.467, area: "extended" },
  { name: "Jülich", lat: 50.922, lng: 6.362, area: "extended" },
  { name: "Heimbach", lat: 50.637, lng: 6.478, area: "extended" },
  { name: "Hellenthal", lat: 50.487, lng: 6.431, area: "extended" },
  { name: "Blankenheim", lat: 50.437, lng: 6.651, area: "extended" },
  { name: "Nürburg", lat: 50.343, lng: 6.953, area: "extended" },
  { name: "Adenau", lat: 50.383, lng: 6.933, area: "extended" },
  { name: "Winnerath", lat: 50.4169, lng: 6.8822, area: "extended" },
  { name: "Schuld", lat: 50.4439, lng: 6.8975, area: "extended" },
  { name: "Monschau", lat: 50.554, lng: 6.24, area: "extended" },
  { name: "Simmerath", lat: 50.606, lng: 6.3, area: "extended" },
  { name: "Grevenbroich", lat: 51.09, lng: 6.585, area: "extended" },
  { name: "Rommerskirchen", lat: 51.033, lng: 6.69, area: "extended" },
  { name: "Düsseldorf", lat: 51.2277, lng: 6.7735, area: "extended" },
  { name: "Neuss", lat: 51.2042, lng: 6.6879, area: "extended" },
  { name: "Dormagen", lat: 51.095, lng: 6.84, area: "extended" },
  { name: "Hilden", lat: 51.169, lng: 6.939, area: "extended" },
  { name: "Erkrath", lat: 51.223, lng: 6.908, area: "extended" },
  { name: "Haan", lat: 51.193, lng: 7.013, area: "extended" },
  { name: "Solingen", lat: 51.1652, lng: 7.0671, area: "extended" },
  { name: "Leichlingen", lat: 51.106, lng: 7.019, area: "extended" },
  { name: "Leverkusen", lat: 51.0459, lng: 7.0192, area: "extended" },
  { name: "Odenthal", lat: 51.033, lng: 7.117, area: "extended" },
  { name: "Essen", lat: 51.4556, lng: 7.0116, area: "extended" },
  { name: "Gelsenkirchen", lat: 51.5177, lng: 7.0857, area: "extended" },
  { name: "Dortmund", lat: 51.5136, lng: 7.4653, area: "extended" },
  { name: "Wuppertal", lat: 51.2562, lng: 7.1508, area: "extended" },
  { name: "Wetter (Ruhr)", lat: 51.388, lng: 7.395, area: "extended" },
  { name: "Hagen", lat: 51.3671, lng: 7.4633, area: "extended" },
];

// Label used in forms / WhatsApp: "Liblar (Erftstadt)".
export const placeLabel = (l) => (l.parent ? `${l.name} (${l.parent})` : l.name);

// Erftstadt appears in lists as a town; selecting it maps to the town name itself.
export const LIST_ENTRIES = [
  ...LOCATIONS.map((l) => ({ label: placeLabel(l), area: l.area, search: `${l.name} ${l.parent || ""}` })),
  { label: "Erftstadt", area: "core", search: "Erftstadt Liblar Gymnich Lechenich Friesheim" },
].sort((a, b) => a.label.localeCompare(b.label, "de"));

export const normalize = (s = "") =>
  s.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/ß/g, "ss");

export const filterEntries = (q) => {
  const n = normalize(q.trim());
  return n ? LIST_ENTRIES.filter((e) => normalize(e.search + " " + e.label).includes(n)) : LIST_ENTRIES;
};

export const selectCity = (label) => {
  window.dispatchEvent(new CustomEvent("puregloss:select-city", { detail: { city: label } }));
};
